module.exports = __webpack_public_path__ + "static/media/my-account-bg.3a2d6349.jpg";